class CutLibrary extends HTMLElement {
 connectedCallback() {
  if (this.ready) return; this.ready = true;
  this.category = this.querySelector('[data-cut]')?.dataset.category || 'swimwear'; this.selected = null;
  this.addEventListener('click', event => {
   const cut = event.target.closest('[data-cut]');
   const category = event.target.closest('button[data-category]:not([data-cut])');
   if (cut) { this.selected = cut.dataset.cut; this.update(); }
   if (category) { this.category = category.dataset.category; this.selected = null; this.querySelector('[data-compare]').checked = false; this.update(); }
  });
  this.addEventListener('change', () => this.update());
  this.addEventListener('shopify:block:select', event => {
   const detail = this.querySelector(`[data-detail="${CSS.escape(event.detail.blockId)}"]`);
   if (detail) { this.category = detail.dataset.category; this.selected = detail.dataset.detail; this.update(); }
  });
  this.classList.add('is-ready'); this.update();
 }
 update() {
  this.dataset.category = this.category;
  const choices = [...this.querySelectorAll('[data-cut]')];
  if (!choices.some(button => button.dataset.category === this.category)) this.category = choices[0]?.dataset.category;
  const valid = choices.filter(button => button.dataset.category === this.category);
  if (!valid.some(button => button.dataset.cut === this.selected)) this.selected = valid[0]?.dataset.cut;
  choices.forEach(button => { button.hidden = button.dataset.category !== this.category; button.setAttribute('aria-pressed', String(button.dataset.cut === this.selected)); });
  this.querySelectorAll('button[data-category]:not([data-cut])').forEach(button => { button.hidden = !choices.some(cut => cut.dataset.category === button.dataset.category); button.setAttribute('aria-pressed', String(button.dataset.category === this.category)); });
  const compare = this.querySelector('[data-compare]'); compare.disabled = valid.length < 2;
  this.querySelector('.cut-library__comparison').hidden = valid.length < 2;
  const second = this.querySelector('[data-second]');
  const previousSecond = second.value;
  second.replaceChildren(...valid.filter(button => button.dataset.cut !== this.selected).map(button => { const option = document.createElement('option'); option.value = button.dataset.cut; option.textContent = button.textContent.trim(); return option; }));
  if ([...second.options].some(option => option.value === previousSecond)) second.value = previousSecond;
  const comparing = compare.checked && valid.length > 1;
  this.querySelector('.cut-library__second').hidden = !comparing;
  this.querySelector('.cut-library__pictures').classList.toggle('is-comparing', comparing);
  this.querySelectorAll('[data-picture]').forEach(figure => { figure.hidden = figure.dataset.picture !== this.selected && !(comparing && figure.dataset.picture === second.value); figure.style.order = figure.dataset.picture === this.selected ? 0 : 1; });
  this.querySelectorAll('[data-detail]').forEach(detail => { detail.hidden = detail.dataset.detail !== this.selected; });
 }
}
if (!customElements.get('cut-library')) customElements.define('cut-library', CutLibrary);
